export const PersonReadRight = "WEB_MODULE_MESSAGE_ARCHIVE_PERSON_READ";
export const PilotTransportReadRight = "WEB_MODULE_MESSAGE_ARCHIVE_PILOT_TRANSPORT_READ";
export const AdminReadRight = "WEB_MODULE_MESSAGE_ARCHIVE_ADMIN_READ";

export const Rights = [
    PersonReadRight,
    PilotTransportReadRight,
    AdminReadRight
]
